import React, { useEffect, useState } from "react";
import styles from "./NoCameraModal.module.scss";
import CameraIcon from "../../../../assets/no-camera.png";
import { useGlobalContext } from "../../../../scanview/ScanViewerContext";

const NoCameraModal = () => {
  const { noCameraModalConfig } = useGlobalContext();
  const [texts, setTexts] = useState({
    title: "No camera access",
    instructionsText:
      "To scan your card, allow us to use your camera in\n Settings > Privacy > Camera",
    settingsButtonText: "Go to settings",
  });

  const goToSettings = () => {
    window.location.href = "prefs:root=Settings";
  };

  useEffect(() => {
    if (noCameraModalConfig) {
      setTexts((prev) => ({ ...prev, ...noCameraModalConfig }));
    }
  }, [noCameraModalConfig]);

  return (
    <div className={styles.noCameraModalMainContainer}>
      <div className={styles.textsContainer}>
        <img
          className={styles.icon}
          src={CameraIcon}
          alt="black camera with a red line over it"
        />
        <h2 className={styles.title}>{texts.title}</h2>
        <p className={styles.text}>{texts.instructionsText}</p>
      </div>
      <button className={styles.settingsBtn} onClick={goToSettings}>
        {texts.settingsButtonText}
      </button>
    </div>
  );
};

export default NoCameraModal;
